import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function toTitleCase(str: string): string {
    if (!str) return '';
    return str
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatBookingStatus(status: string): string {
    const map: Record<string, string> = {
          pending_confirmation: 'Awaiting Confirmation',
          confirmed: 'Confirmed',
          in_progress: 'In Progress',
          completed: 'Completed',
          cancelled: 'Cancelled',
          cancelled_by_client: 'Cancelled by Client',
          cancelled_by_helper: 'Cancelled by Helper',
          expired: 'Expired',
    };
    return map[status] ?? toTitleCase(status);
}
